<!-- 請求先一覧 -->
<template>
  <v-container fluid>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2">
            mdi-briefcase-account-outline
          </v-icon>
          請求先
        </h2>
        <v-spacer class="mt-2" />
      </v-col>
    </v-row>
    <!-- /ヘッダー -->

    <!-- 検索ブロック -->
    <v-row>
      <v-col>
        <v-expansion-panels accordion>
          <v-expansion-panel>
            <v-expansion-panel-header class="panel-header-color panel-selectable">
              <strong>
                <v-icon class="panel-header-color">
                  mdi-magnify
                </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="searchForm.code"
                        dense
                        hide-details="auto"
                        label="請求先コード"
                        clearable
                        outlined
                        persistent-placeholder
                        rounded
                        @blur="searchButtonClickEvent()"
                        @click:clear="searchForm.code = null; searchButtonClickEvent()"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        v-model="searchForm.name"
                        dense
                        hide-details="auto"
                        label="請求先名"
                        clearable
                        outlined
                        persistent-placeholder
                        placeholder="部分一致で検索"
                        rounded
                        @blur="searchButtonClickEvent()"
                        @click:clear="searchForm.name = null; searchButtonClickEvent()"
                      />
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" md="4">
                      <v-select
                        v-model="searchForm.closingDateType"
                        :items="closingDateTypes"
                        dense
                        hide-details="auto"
                        label="締め日"
                        clearable
                        outlined
                        persistent-placeholder
                        rounded
                        @change="searchButtonClickEvent()"
                      />
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-select
                        v-model="searchForm.paymentMethodType"
                        :items="paymentMethodTypes"
                        dense
                        hide-details="auto"
                        label="入金方法"
                        clearable
                        outlined
                        persistent-placeholder
                        rounded
                        @change="searchButtonClickEvent()"
                      />
                    </v-col>
                  </v-row>
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    @click="searchButtonClickEvent"
                  >
                    <v-icon>mdi-magnify</v-icon>&nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索ブロック -->

    <!-- ボタン -->
    <v-row>
      <v-col cols="12" class="text-right">
        <template
          v-if="$vuetify.breakpoint.mdAndUp"
        >
          <v-btn
            color="info"
            @click="exportButtonClickEvent"
          >
            <v-icon>mdi-file-download-outline</v-icon>&nbsp;CSV出力
          </v-btn>
          &nbsp;
          <v-btn
            color="info"
            @click="importButtonClickEvent"
          >
            <v-icon>mdi-file-upload-outline</v-icon>&nbsp;CSV取込
          </v-btn>
        </template>
        <template
          v-else
        >
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                color="info"
                dark
                v-bind="attrs"
                v-on="on"
              >
                CSVファイル
                <v-icon small>
                  mdi-file-outline
                </v-icon>
              </v-btn>
            </template>
            <v-list>
              <v-list-item
                @click="exportButtonClickEvent"
              >
                <v-list-item-title>
                  CSV出力
                </v-list-item-title>
              </v-list-item>
              <v-list-item
                @click="importButtonClickEvent"
              >
                <v-list-item-title>
                  CSV取込
                </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        &emsp;
        <v-btn
          color="primary"
          @click="addButtonClickEvent"
        >
          請求先の追加&nbsp;<v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <!-- /ボタン -->

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card class="rounded-card" flat>
          <v-data-table
            :headers="tableHeaders"
            :items="billing_addresses"
            :items-per-page="-1"
            disable-sort
            disable-pagination
            hide-default-footer
          >
            <template v-slot:[`item.name`]="{ item }">
              <span :title="item.name">{{ item.name | truncate(20) }}</span>
            </template>

            <template v-slot:[`item.address`]="{ item }">
              <span>{{ item.address | truncate(25) }}</span>
            </template>

            <template v-slot:[`item.created_at`]="{ item }">
              {{ item.created_at | unix_datetime_format }}
            </template>
            <template v-slot:[`item.updated_at`]="{ item }">
              {{ item.updated_at | unix_datetime_format }}
            </template>

            <template v-slot:[`item.editable`]="{item}">
              <v-btn
                :icon="$vuetify.breakpoint.mdAndUp"
                :text="$vuetify.breakpoint.smAndDown"
                :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                @click="showButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-file-document-outline
                </v-icon>
                <span v-else>
                  参照
                </span>
              </v-btn>
              <v-btn
                :icon="$vuetify.breakpoint.mdAndUp"
                :text="$vuetify.breakpoint.smAndDown"
                :color="`info ${$vuetify.breakpoint.mdAndUp ? 'darken-2': null}`"
                @click="editButtonClickEvent(item)"
              >
                <v-icon v-if="$vuetify.breakpoint.mdAndUp">
                  mdi-note-edit
                </v-icon>
                <span v-else>編集</span>
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->
    <confirm ref="confirm" />
  </v-container>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import Confirm from '../../../../components/Confirm'
import DownloadMixin from '../../../../mixins/download-mixin'
import CustomPagination from "@/driver/components/_CustomPagination.vue";
/**
 * 請求先
 */
export default {
  name: 'DriverMasterBillingAddresses',
  components: {
    CustomPagination,
    Confirm
  },
  filters: {
  },
  mixins: [
    DownloadMixin,
  ],
  props: {},
  data () {
    return {
      page: 1,
      perPage: 50,
      totalVisible: 7,
      tableHeaders: [
        { text: 'コード', value: 'code' },
        { text: '請求先', value: 'name' },
        { text: '郵便番号', value: 'zip_code' },
        { text: '所在地', value: 'address' },
        { text: '締め日', value: 'close_day_type_name' },
        { text: '入金方法', value: 'payment_method_type_name' },
        { text: '請求先テナント', value: 'billing_tenant_name' },
        { text: '編集/削除', value: 'editable', align: 'end' },
      ],
      /** 締め日 */
      closingDateTypes: [
        { value: 'closing_5th_day', text: '5日' },
        { value: 'closing_10th_day', text: '10日' },
        { value: 'closing_15th_day', text: '15日' },
        { value: 'closing_20th_day', text: '20日' },
        { value: 'closing_25th_day', text: '25日' },
        { value: 'closing_last_day', text: '末日' },
      ],
      /** 入金方法 */
      paymentMethodTypes: [
        { value: 'bank_transfer', text: '銀行振込' },
        { value: 'account_transfer', text: '口座振替' },
        { value: 'bill_transfer', text: '手形' },
        { value: 'cash', text: '現金' },
      ],
      searchForm: {
        code: null,
        name: null,
        closingDateType: null,
        paymentMethodType: null,
      },
      billing_addresses: [],
    }
  },
  computed: {
    ...mapState('DriverMasterBillingAddress', {
      pagination: 'pagination',
      searchCondition: 'condition',
    }),
  },
  watch: {},
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState()
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination()
    }
    this.searchForm.code = this.searchCondition.code
    this.searchForm.name = this.searchCondition.name
    this.searchForm.closingDateType = this.searchCondition.closing_date_type
    this.searchForm.paymentMethodType = this.searchCondition.payment_method_type
    this.page = this.pagination.current_page
    this.perPage = this.searchCondition.limit
    this.searchBillingAddresses()
  },
  methods: {
    ...mapActions('DriverMasterBillingAddress', {
      fetchBillingAddresses: 'index',
      deleteBillingAddresses: 'destroy',
      resetState: 'resetState',
      resetPagination: 'resetPagination',
    }),
    /**
     * 検索ボタン クリックイベント
     */
    searchButtonClickEvent () {
      this.page = 1
      this.searchBillingAddresses()
    },
    /**
     * 追加ボタン クリックイベント
     */
    addButtonClickEvent () {
      this.$router.push({name: 'DriverMasterBillingAddressNew'})
    },
    /**
     * 参照ボタン クリックイベント
     * @param item { Object }
     */
     showButtonClickEvent (item) {
      this.$router.push({name: 'DriverMasterBillingAddress', params: { id: item.id }})
    },
    /**
     * 編集ボタン クリックイベント
     * @param item { Object }
     */
    editButtonClickEvent (item) {
      this.$router.push({name: 'DriverMasterBillingAddressEdit', params: { id: item.id }})
    },
    /**
     * 削除ボタン クリックイベント
     * @param item { Object }
     */
    deleteButtonClickEvent (item) {
      this.$refs.confirm.showDeleteConfirm().then((confirm) => {
        this.$refs.confirm.close()
        if (confirm) {
          this.deleteBillingAddresses({ id: item.id }).then(() =>{
            this.searchBillingAddresses()
          })
        }
      })
    },
    changePage(page) {
      this.page = page;
      this.searchBillingAddresses()
    },
    changePerPage (perPage) {
      this.perPage = perPage
      this.page = 1
      this.searchBillingAddresses()
    },
    searchBillingAddresses () {
      let params = this.buildParam('json')
      this.fetchBillingAddresses(params).then((content) => {
        this.billing_addresses = content.billing_addresses
      })
    },
    buildParam (format) {
      return {
        code: this.searchForm.code,
        name: this.searchForm.name,
        closing_date_type: this.searchForm.closingDateType,
        payment_method_type: this.searchForm.paymentMethodType,
        page: this.page,
        limit: this.perPage,
        format: format
      }
    },
    exportButtonClickEvent () {
      let params = this.buildParam('csv')
      this.fetchBillingAddresses(params).then((content) => {
        this.downloadCsv(content, '請求先')
      })
    },
    /* イベントがないとエラーとなるのでひとまず設置 */
    importButtonClickEvent () {
      this.$router.push({name: 'DriverMasterBillingAddressCsvImport'})
    },
  }
}
</script>

<style scoped lang="scss">

</style>
